import { Container, Box } from "@mui/material";
import React, { useState } from 'react';
import CustomerValidation from "../utilities/CustomerValidation/CustomerValidation";
import customer from '../../images/customerIcon.svg';
import check from '../../images/checkIcon.svg';
import date from '../../images/dateIcon.svg';
import Quote from "../utilities/Quotes/Quotes";
import SortTable from "../utilities/SortTable/SortTable";
import { ValidationWrapper } from './ValidationStyled';
import CountryData from "../utilities/CountryData/CountryData";
import AlertDialog from "../utilities/Model/Model";
import OverrideFooterButtons from "../utilities/OverrideFooterButtons/OverRideFooterButton";
import Product from "../utilities/Product/Product";
import { stubTrue } from "lodash";
import { Constant } from "../Dashboard/QuoteValidation/Content";
// overwrite logs
const headers1 = [
  'SI.No',
  'Override By',
  'Date',
  'Time',
  'Override Data'
];
const rows1 = [
  ['1', 'Francis Reynold', '12/08/2023', '05:00 PM', 'Utilization % is not range of India'],
  ['2', 'Will Chavez', '12/02/1950', '07:00 PM', 'Head count for France is matching with BOB refrence'],
  ['3', 'Alex Jackson', '28/06/2017', '10:00 AM', 'Utilization % is not range of India'],
  ['4', 'Roy Smith', '28/08/2013', '05:00 PM', 'Head count for France is matching with BOB refrence'],
  ['5', 'Jose Marshall', '28/07/2001', '10:00 PM', 'Head count for France is matching with BOB refrence'],

];


const ValidationTab = () => {

    const [isAccordionOpen, setIsAccordionOpen] = useState(true);

    const handleAccordionToggle = () => {
        // Toggle the open/closed state of the accordion
        setIsAccordionOpen(!isAccordionOpen);
    };

const ProductVarient=[
  {id:1,componentName:"Single session therapy",checked:true},
  {id:2,componentName:"Scheduled phone sessions",checked:true},
  {id:3,componentName:"Work-Life Core",checked:true},
  {id:4,componentName:"Enhanced Financial Services",checked:true},
];
const rowsDistribution = [
  { id: 'UK', name: 'EAP', componentList: ProductVarient},
  { id: 'India', name: 'EAP', componentList: ProductVarient},
  { id: 'Japan', name: 'EAP', componentList: ProductVarient},
  { id: 'SK', name: 'EAP', componentList: ProductVarient },
  { id: 'China', name: 'EAP', componentList:ProductVarient },
 ];


 
  const customersData = [
    {
      icon: customer,
      title: "Customer",
      description: "ABB Holdings ,Zurich",
    },
    {
      icon: check,
      title: "Amount",
      description: "234.0 USD",
    },
    {
      icon: date,
      title: "Date Created",
      description: "8-4-2023",
    }
  ];
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState('');
  const handleSubmit = (event) => {
    event.preventDefault();
    setShowNotification(true);
    console.log(showNotification);
    setNotificationMessage('Would you like to override this quote?')
};
const handleCloseNotification = () => {
  setShowNotification(false);
};

  return (

    <ValidationWrapper>

      <Box className="boxWrapper">

        <Box className="boxContainer">


          <CustomerValidation customers={customersData} />
          <Quote />



        </Box>
        <CountryData country={rowsDistribution} />
        
        <Box >
       
            <Box className="priceCalculation">
            <h3>Overwrite Logs</h3>
              <SortTable headers={headers1} rows={rows1} />
            </Box>
        </Box>


      </Box>
      <Box>
            <OverrideFooterButtons leftButton={Constant.CANCEL}   rightButton={Constant.OVERRIDE}  onSubmitButton={handleSubmit}/>
      </Box>
      {showNotification && <AlertDialog show={showNotification} Message={notificationMessage} onClose={handleCloseNotification} />}
    </ValidationWrapper>

  )
}

export default ValidationTab;